import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';
import { parse } from 'iso8601-duration';
import InfiniteScroll from "react-infinite-scroll-component";
import InputLabel from '@material-ui/core/InputLabel';
import Tooltip from '@material-ui/core/Tooltip';
import SegmentDetail from './SegmentDetail';
import { connect } from "react-redux";
import {
    getCarriers
} from "../../store/actions/flights/Flights";



const useStyles = makeStyles((theme) => ({
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: "4%",
        marginBottom: "2%",
    },
    main: {
        paddingTop: '10%', backgroundColor: "rgb(246, 249, 252)", minHeight: "100vh",
        [theme.breakpoints.down("sm")]: {
            paddingTop: '32%',
        },
    }
}));

const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {

    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

function Flights(props) {
    const [spacing, setSpacing] = React.useState("Return");
    const classes = useStyles();
    const search = useLocation().search;
    const journeyType = new URLSearchParams(search).get('journeyType');
    const departureDate = new URLSearchParams(search).get('departureDate');
    const arrivalDate = new URLSearchParams(search).get('arrivalDate');
    const adults = new URLSearchParams(search).get('adults');
    const flightClass = new URLSearchParams(search).get('flightClass');
    const departureAirport = new URLSearchParams(search).get('departureAirport');
    const arrivalAirport = new URLSearchParams(search).get('arrivalAirport');
    const kids = new URLSearchParams(search).get('kids');
    const [flights, setFlights] = useState([])
    const [meta, setMeta] = useState(null)
    const [loading, setLoading] = useState(false);
    const [offerId, setOfferId] = useState(null);
    const [sortBy, setSortBy] = useState('total_amount');
    const [stops, setStops] = useState(2);

    useEffect(() => {
        fetchData()
    }, [])

    const fetchData = async (loadNew) => {
        if (departureAirport && !loading) {
            let slices = [{
                "origin": departureAirport,
                "destination": arrivalAirport,
                "departure_date": departureDate
            }]
            let passengers = []
            for (let i = 0; i < adults; i++) {
                passengers.push({
                    "family_name": "",
                    "given_name": "",
                    "type": "adult"
                })
            }
            if (journeyType === 'Return') {
                slices.push({
                    "origin": arrivalAirport,
                    "destination": departureAirport,
                    "departure_date": arrivalDate
                })
            }
            setLoading(true)
            if (offerId) {
                let queryParam = `/flights/airlines?offer_request_id=${offerId}&sort=${sortBy}&limit=20&max_connections=${stops}`
                if (meta && meta.after && !loadNew) {
                    queryParam += `&after=${meta.after}`
                }
                let response2 = await axios.get(queryParam)
                if (response2 && response2.data && response2.data.data) {
                    let data = response2.data.data
                    if (data && data.data) {
                        if (loadNew)
                            setFlights(data.data)
                        else
                            setFlights(flights.concat(data.data))
                        setMeta(data.meta)
                    }
                }
            } else {
                let response = await axios.post(`/flights/offers`, {
                    data: {
                        slices: slices,
                        passengers: passengers
                    }
                })
                if (response && response.data && response.data.data) {
                    let data = response.data.data
                    setOfferId(data.id)
                    let queryParam = `/flights/airlines?offer_request_id=${data.id}&sort=${sortBy}&limit=20&max_connections=${stops}`
                    if (meta && meta.after && !loadNew) {
                        queryParam += `&after=${meta.after}`
                    }
                    let response2 = await axios.get(queryParam)
                    if (response2 && response2.data && response2.data.data) {
                        let data = response2.data.data
                        if (data && data.data) {
                            if (loadNew)
                                setFlights(data.data)
                            else
                                setFlights(flights.concat(data.data))
                            setMeta(data.meta)
                        }
                    }
                }
            }
            setLoading(false)
        }
    }

    const handleSortChange = (e) => {
        setSortBy(e.target.value)
        setFlights([])
        setMeta(null)
    }

    const handleStopChange = (e) => {
        setStops(e.target.value)
        setFlights([])
        setMeta(null)
    }

    useEffect(() => {
        fetchData(true)
    }, [sortBy, stops])


    const findDuration = (d1) => {
        return d1.replace('P', '').replace('D', 'd ').replace('T', '').replace('H', 'h ').replace('M', 'm')
    }

    const getDateDifference = (d1, d2) => {
        //d1 > d2
        let a = moment(d1);
        let b = moment(d2);

        let min = a.diff(b, 'minutes')
        let hr = a.diff(b, 'hours')
        return hr + "h " + (min - hr * 60) + "m"
    }



    const handleChange = (event) => {
        setSpacing(Number(event.target.value));
    };

    return (
        <div className={classes.main}>
            <div className="container" >
                <div className="mr-0 pl-0">
                    <Grid container>
                        <Grid item xs="12">
                            <Paper className={classes.control} elevation={0}>
                                <Grid container spacing={4}>
                                    <Grid item xs="12" sm="10" style={{ textAlign: "left" }}>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px',
                                            marginRight: "15px"
                                        }} component="span">{journeyType}</Typography>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px',
                                            marginRight: "15px"
                                        }} component="span">{moment(departureDate).format('ddd, ll')} {journeyType === 'Return' ? '- ' + moment(arrivalDate).format('ddd, ll') : ''}</Typography>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px',
                                            marginRight: "15px"
                                        }} component="span">{adults} Passenger</Typography>
                                        <Typography style={{
                                            color: 'black',
                                            background: '#E2E2E8',
                                            padding: '6px',
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            borderRadius: '4px'
                                        }} component="span">{flightClass}</Typography>
                                    </Grid>
                                    <Grid item xs="12" sm="2">
                                        <Button variant="contained" color="primary" fullWidth style={{ backgroundColor: "#7B68EE" }} onClick={() => {
                                            props.history.push(`/flights`)
                                        }}>
                                            {'Edit'}
                                        </Button>
                                    </Grid>
                                    <Grid item xs="12" sm="6">
                                        <Typography style={{ textAlign: "left", fontWeight: "bold", fontSize: "27px" }}>{departureAirport}
                                            <svg width="24" height="24" viewBox="0 0 24 24" aria-label="sync" class="jsx-3696443798 ff-icon">
                                                <path d="M21.65,7.65l-2.79-2.79C18.54,4.54,18,4.76,18,5.21V7H4C3.45,7,3,7.45,3,8v0c0,0.55,0.45,1,1,1h14v1.79 c0,0.45,0.54,0.67,0.85,0.35l2.79-2.79C21.84,8.16,21.84,7.84,21.65,7.65z"></path>
                                                {journeyType === 'Return' && <path d="M2.35,16.35l2.79,2.79C5.46,19.46,6,19.24,6,18.79V17h14c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H6v-1.79 c0-0.45-0.54-0.67-0.85-0.35l-2.79,2.79C2.16,15.84,2.16,16.16,2.35,16.35z"></path>}
                                            </svg> {arrivalAirport}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs="4" sm="2">
                                <FormControl fullWidth>
                                    <InputLabel id="demo-customized-sort-label">SORT</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-customized-sort-label"
                                        id="demo-customized-sort"
                                        value={sortBy}
                                        onChange={handleSortChange}
                                    >
                                        <MenuItem value={'total_amount'}>Least expensive first</MenuItem>
                                        <MenuItem value={'-total_amount'}>Most expensive first</MenuItem>
                                        <MenuItem value={'total_duration'}>Shortest duration first</MenuItem>
                                        <MenuItem value={'-total_duration'}>Longest duration first</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs="4" sm="2">
                                <FormControl fullWidth>
                                    <InputLabel id="demo-customized-stops-label">STOPS</InputLabel>
                                    <Select
                                        fullWidth
                                        labelId="demo-customized-stops-label"
                                        id="demo-customized-stops"
                                        value={stops}
                                        onChange={handleStopChange}
                                    >
                                        <MenuItem value={0}>Direct</MenuItem>
                                        <MenuItem value={1}>Single</MenuItem>
                                        <MenuItem value={2}>Multiple</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid item xs="12" style={{ marginTop: '40px' }}>
                            {!loading && (!flights || flights.length === 0) && <Typography>{"No Flights Available. Please change the search criteria."}</Typography>}
                            <InfiniteScroll
                                dataLength={flights.length} //This is important field to render the next data
                                next={fetchData}
                                hasMore={!meta || meta.after}
                                endMessage={
                                    <p style={{ textAlign: 'center' }}>

                                    </p>
                                }
                                // below props only if you need pull down functionality
                                refreshFunction={fetchData}
                            >
                                {flights.map((flight) => {
                                    return <Paper className={classes.control} elevation={0}><Grid container spacing={4}>
                                        <Grid item xs="12" sm="10" style={{ textAlign: "left", borderRight: "1px solid black" }}>
                                            {flight.slices.map((airport) => {
                                                return <Accordion square>
                                                    <AccordionSummary ><Grid container style={{ marginBottom: '20px' }}>
                                                        <Grid item sm="1" xs="2">
                                                            <img title="Grospick Airways" height="48px" width="48px" src={`https://images.kiwi.com/airlines/64/${airport.segments[0].marketing_carrier.iata_code}.png`} class="jsx-1041521223" />
                                                        </Grid>
                                                        <Grid item sm="7" xs="10">
                                                            <Grid container>
                                                                <Grid item xs="12">
                                                                    <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>{moment(airport.segments[0].departing_at).format('LT')} - {moment(airport.segments[airport.segments.length - 1].arriving_at).format('LT')}</Typography>
                                                                </Grid>
                                                                <Grid item xs="12">
                                                                    <Typography stle={{ fontSize: "14px" }}>{airport.fare_brand_name ? airport.fare_brand_name : airport.segments[0].passengers[0].cabin_class_marketing_name} · {airport.segments[0].marketing_carrier.name}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item sm="2" xs="10">
                                                            <Grid container>
                                                                <Grid item xs="12">
                                                                    <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>{findDuration(airport.duration)}</Typography>
                                                                </Grid>
                                                                <Grid item xs="12">
                                                                    <Typography stle={{ fontSize: "14px" }}>{airport.origin.iata_code} - {airport.destination.iata_code}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item sm="2" xs="2">
                                                            <Grid container>
                                                                <Grid item xs="12">
                                                                    <Typography style={{ fontWeight: "bold", fontSize: "16px" }}>{airport.segments.length === 1 ? 'Direct' : (airport.segments.length - 1) + ' Stop'}</Typography>
                                                                </Grid>
                                                                {airport.segments.length > 1 &&
                                                                    airport.segments.map((segment, index) => {
                                                                        if (index !== airport.segments.length - 1) {
                                                                            return (<Grid item xs="12">
                                                                                <Typography style={{ fontSize: "14px" }}>{getDateDifference(airport.segments[index + 1].departing_at, segment.arriving_at) + ' ' + segment.destination.iata_code}</Typography>
                                                                            </Grid>)
                                                                        }
                                                                    })
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <Grid container style={{ marginBottom: '20px' }}>


                                                            {airport.segments.map((segment, index) => {
                                                                return <SegmentDetail segment={segment} index={index} segments={airport.segments} />
                                                            })}
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            })}

                                        </Grid>
                                        <Grid item xs="12" sm="2">
                                            <Grid container>
                                                <Grid item xs="12">
                                                    <Button variant="contained" color="primary" fullWidth style={{ backgroundColor: "rgb(1, 160, 90)" }} onClick={() => {
                                                        props.history.push(`/flights-book/${flight.id}?journeyType=${journeyType}&departureAirport=${departureAirport}&arrivalAirport=${arrivalAirport}&departureDate=${departureDate}&arrivalDate=${arrivalDate}&adults=${adults}&kids=${kids}&flightClass=${flightClass}`);

                                                    }}>
                                                        A${flight.total_amount}
                                                    </Button>
                                                </Grid>
                                                <br></br>
                                                <Grid item xs="12" style={{
                                                    textAlign: 'left',
                                                    marginTop: '20px'
                                                }}>
                                                    <Typography component="span" style={{ fontSize: '12px' }}><svg style={{ marginTop: '12px' }} width="22" height="22" viewBox="0 0 24 24" aria-label="cloud" class="jsx-3696443798 ff-icon"><path d="M12.9 4.69332C12.4467 2.39332 10.4267 0.666656 8 0.666656C6.07333 0.666656 4.4 1.75999 3.56667 3.35999C1.56 3.57332 0 5.27332 0 7.33332C0 9.53999 1.79333 11.3333 4 11.3333H12.6667C14.5067 11.3333 16 9.83999 16 7.99999C16 6.23999 14.6333 4.81332 12.9 4.69332ZM12.6667 9.99999H4C2.52667 9.99999 1.33333 8.80666 1.33333 7.33332C1.33333 5.85999 2.52667 4.66666 4 4.66666H4.47333C4.91333 3.12666 6.32 1.99999 8 1.99999C10.0267 1.99999 11.6667 3.63999 11.6667 5.66666V5.99999H12.6667C13.7733 5.99999 14.6667 6.89332 14.6667 7.99999C14.6667 9.10666 13.7733 9.99999 12.6667 9.99999Z"></path></svg></Typography>
                                                    <Typography component="span" style={{ fontSize: '12px' }}>{flight.total_emissions_kg}kg CO<sub>2</sub></Typography>
                                                </Grid>
                                                {!flight.payment_requirements?.requires_instant_payment &&
                                                    <Grid item xs="12" style={{
                                                        textAlign: 'left',
                                                    }}>
                                                        <Typography component="span" style={{ fontSize: '12px' }}><svg width="16" height="16" viewBox="0 0 24 24" aria-label="event_seat" class="jsx-3696443798 ff-icon"><g><rect fill="none" height="24" width="24" x="0"></rect></g><g><g><g><path d="M4,18v3h3v-3h10v3h3v-6H4V18z M19,10h3v3h-3V10z M2,10h3v3H2V10z M17,13H7V5c0-1.1,0.9-2,2-2h6c1.1,0,2,0.9,2,2V13z"></path></g></g></g></svg>&nbsp;&nbsp;</Typography>
                                                        <Typography component="span" style={{ fontSize: '12px' }}>Hold <Tooltip title={`Hold space for ${moment(flight.payment_requirements?.payment_required_by).diff(moment(), 'days')} days`}><a style={{ color: "black", textDecoration: "underline" }}>space</a></Tooltip></Typography>
                                                    </Grid>
                                                }
                                                {flight.slices[0].segments[0].passengers[0].baggages && flight.slices[0].segments[0].passengers[0].baggages.length > 0 &&
                                                    <Grid item xs="12" style={{
                                                        textAlign: 'left',
                                                    }}>
                                                        <Typography component="span" style={{ fontSize: '11px' }}><svg width="16" height="16" viewBox="0 0 24 24" aria-label="checked_bag" class="jsx-3696443798 ff-icon"><path d="M22 19H2V21H22V19M4 15C4 15.5 4.2 16 4.6 16.4C5 16.8 5.5 17 6 17V6C5.5 6 5 6.2 4.6 6.6C4.2 7 4 7.5 4 8V15M13.5 6H10.5C10.5 5.6 10.6 5.2 10.9 4.9C11.2 4.6 11.5 4.5 12 4.5C12.4 4.5 12.8 4.6 13.1 4.9C13.3 5.2 13.5 5.6 13.5 6M7 6V17H17V6H15C15 5.2 14.7 4.5 14.1 3.9S12.8 3 12 3C11.2 3 10.5 3.3 9.9 3.9C9.3 4.5 9 5.2 9 6H7M18 17C18.5 17 19 16.8 19.4 16.4C19.8 16 20 15.5 20 15V8C20 7.5 19.8 7 19.4 6.6C19 6.2 18.5 6 18 6V17Z"></path></svg>&nbsp;&nbsp;</Typography>
                                                        <Typography component="span" style={{ fontSize: '11px' }}>Includes {flight.slices[0].segments[0].passengers[0].baggages.length} checked bag</Typography>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    </Paper>
                                })}
                            </InfiniteScroll>
                            {loading && <CircularProgress />}

                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
}


const mapStateWithProps = (state) => ({
    carriers: state.flight.carriers,
});
const mapDispatchWithProps = (dispatch) => {
    return {
        getCarriers: () => dispatch(getCarriers()),
    };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(Flights)